import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'
import type { WebRegulatorBrokerItem } from './regulator-blacklist'

const REGULATOR_MEMBER_LIST_API_PATH = '/api/v4/bit/web/regulator/member/list'

export type WebRegulatorMemberListResponseData = {
  memberCount?: number
  memberList?: WebRegulatorBrokerItem[]
}

export type WebRegulatorMemberListWrappedResponse = {
  data?: WebRegulatorMemberListResponseData
  succeed?: boolean
  code?: number
  message?: string
}

export type GetWebRegulatorMemberListParams = {
  regulatorCode: string
  business?: string
  page?: number
  size?: number
}

export const getRegulatorMemberList = async (
  params: GetWebRegulatorMemberListParams,
): Promise<WebRegulatorMemberListResponseData | null> => {
  if (!params.regulatorCode) {
    return null
  }

  const api = useEnvApi()
  const requestConfig = {
    baseURL: api.wikibitBffGo,
    url: REGULATOR_MEMBER_LIST_API_PATH,
    method: 'GET' as const,
    params: {
      regulatorCode: params.regulatorCode,
      business: params.business || '',
      page: params.page || 1,
      size: params.size || 20,
    },
  }

  const response = import.meta.server
    ? await useServerFetch<WebRegulatorMemberListWrappedResponse>(requestConfig)
    : await request<unknown, WebRegulatorMemberListWrappedResponse>(requestConfig)

  if (!response || !response.data) {
    return null
  }

  return response.data
}
